export const SocialData = [
   {
      platform: "Instagram",
      link: "https://www.instagram.com/drishaypoudel/?hl=en",
      icon: require("../../assets/icons/instagram.png"),
   },
   {
      platform: "Facebook",
      link: "https://www.facebook.com/drishay.poudel/",
      icon: require("../../assets/icons/facebook.png"),
   },
   {
      platform: "Twitter",
      link: "https://twitter.com/drishaypoudel",
      icon: require("../../assets/icons/twitter.png"),
   },
   {
      platform: "Linkedin",
      link: "https://www.linkedin.com/in/drishyapoudel/",
      icon: require("../../assets/icons/linkedin.png"),
   },
   {
      platform: "github",
      link: "https://github.com/drishyap",
      icon: require("../../assets/icons/github.png"),
   },
];
